<template>
  <div class="flex flex-col items-center justify-center py-32 px-4">
    <div class="rounded-full bg-gray-100 p-4 mb-5">
      <UserX class="h-8 w-8 text-gray-400" :stroke-width="1.5" />
    </div>
    <h2 class="text-lg font-semibold text-gray-900 mb-1">{{ entity }} not found</h2>
    <p class="text-sm text-gray-500 mb-6">This {{ entity.toLowerCase() }} may have been removed or doesn't exist.</p>
    <button
      class="inline-flex items-center gap-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
      @click="goBack"
    >
      <ArrowLeft class="h-4 w-4" />
      Go back
    </button>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { UserX, ArrowLeft } from 'lucide-vue-next';

const { entity = 'Contact' } = defineProps<{ entity?: string }>();

const router = useRouter();

const goBack = () => {
  if (window.history.state.back) {
    router.back();
  } else {
    router.push({ name: 'Candidates' });
  }
};
</script>
